// /**
//  * Order detail -CSV
//  */

// React
import React from 'react';
import { CSVLink } from 'react-csv';
import { Order } from '../orders/interfaces';

type Props = {
  data: Order[];
  loading: boolean;
};

function CSV(props: Props) {

  const flattData = (data: any) => {
    return data.map((item: any) => {
      return {
        orderItemId: item.id,
        productName: item.productName,
        productCode: item.productCode,
        variantCode: item.variantCode,
        variantId: item.variantId,
        amount: item.amount
      }
    });
  }

  return (
    <CSVLink
      data={flattData(props.data)}
      filename="Orders.csv"
      style={{
        backgroundColor: '#DFA01F',
        padding: '7px',
        color: '#fff',
        marginLeft: '5px',
        marginBottom: '5px',
        textDecoration: 'none',
        borderRadius: '5px'
      }}
    >
      دانلود CSV
    </CSVLink>
  );
}

export default CSV;
